import { pageTitle } from 'ember-page-title';
import { t } from 'ember-intl';
import { BreadcrumbsItem } from 'core/components';

import PageAccountSettingsBasicInfo from 'hcp/components/page/account-settings/basic-info';

<template>
  {{pageTitle (t "components.page.account-settings.title")}}

  <BreadcrumbsItem
    @text={{t
      "components.page.account-settings.breadcrumb"
      pageName=(t "components.page.account-settings.nav.info")
      htmlSafe="true"
    }}
  />

  <PageAccountSettingsBasicInfo @model={{@controller.model}} />
</template>
